import React from 'react';
import Icon from '../../../components/AppIcon';
import Button from '../../../components/ui/Button';
import { format } from 'date-fns';

const InterviewRequestCard = ({ request, onSchedule, onSendReminder, onViewDetails }) => {
  const getStatusColor = (status) => {
    switch (status) {
      case 'scheduled':
        return 'bg-primary/10 text-primary border-primary/20';
      case 'pending':
        return 'bg-warning/10 text-warning border-warning/20';
      case 'completed':
        return 'bg-success/10 text-success border-success/20';
      case 'rescheduled':
        return 'bg-accent/10 text-accent border-accent/20';
      default:
        return 'bg-muted/10 text-muted-foreground border-muted/20';
    }
  };

  const getStatusIcon = (status) => {
    switch (status) {
      case 'scheduled':
        return 'Calendar';
      case 'pending':
        return 'Clock';
      case 'completed':
        return 'CheckCircle';
      case 'rescheduled':
        return 'RefreshCw';
      default:
        return 'AlertCircle';
    }
  };

  return (
    <div className="bg-background border border-border rounded-lg p-4 hover:shadow-md transition-shadow">
      <div className="flex items-start gap-3">
        <img
          src={request?.candidatePhoto}
          alt={request?.candidatePhotoAlt}
          className="w-12 h-12 rounded-full object-cover"
        />
        <div className="flex-1 min-w-0">
          <div className="flex items-start justify-between gap-2">
            <div className="flex-1 min-w-0">
              <h3 className="font-semibold text-foreground truncate">{request?.candidateName}</h3>
              <p className="text-sm text-muted-foreground truncate">{request?.position}</p>
            </div>
            <span className={`px-2 py-1 rounded-full text-xs font-medium border flex items-center gap-1 ${getStatusColor(request?.status)}`}>
              <Icon name={getStatusIcon(request?.status)} size={12} />
              {request?.status?.charAt(0)?.toUpperCase() + request?.status?.slice(1)}
            </span>
          </div>

          <div className="mt-2 space-y-1">
            <div className="flex items-center gap-2 text-xs text-muted-foreground">
              <Icon name="Briefcase" size={12} />
              <span>{request?.experience}</span>
            </div>
            {request?.scheduledDate && (
              <div className="flex items-center gap-2 text-xs text-muted-foreground">
                <Icon name="Calendar" size={12} />
                <span>{format(new Date(request?.scheduledDate), 'MMM dd, yyyy hh:mm a')}</span>
              </div>
            )}
            {request?.meetingPlatform && (
              <div className="flex items-center gap-2 text-xs text-muted-foreground">
                <Icon name="Video" size={12} />
                <span>{request?.meetingPlatform}</span>
              </div>
            )}
          </div>

          <div className="mt-3 flex items-center gap-2">
            {request?.status === 'pending' && (
              <Button
                size="xs"
                onClick={() => onSchedule?.(request)}
                iconName="Calendar"
              >
                Schedule
              </Button>
            )}
            {request?.status === 'scheduled' && (
              <Button
                size="xs"
                variant="outline"
                onClick={() => onSendReminder?.(request)}
                iconName="Bell"
              >
                Remind
              </Button>
            )}
            <Button
              size="xs"
              variant="ghost"
              onClick={() => onViewDetails?.(request)}
              iconName="Eye"
            >
              Details
            </Button>
          </div>
        </div>
      </div>
    </div>
  );
};

export default InterviewRequestCard;